import script from "./NoteSendingModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoteSendingModal.vue?vue&type=script&lang=ts&setup=true"

import "./NoteSendingModal.vue?vue&type=style&index=0&id=666b0626&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666b0626"]])

export default __exports__